<template>
  <div id="app">
    <div class="bg"
         v-if="['home', 'portfolio', 'calculator', 'hydrocalc', 'contact', '404'].indexOf($route.name) !== -1">
    </div>

    <section :class="{'hero header': true, 'is-fullheight is-fh-adj': $route.name === 'home'}">
      <!-- Hero header: will stick at the top -->
      <div class="hero-head head-has-affix">
        <header class="nav head-affix">
          <div class="container">
            <div class="nav-left">
              <router-link :to="{name: 'home'}" class="nav-item">
                <img src="./assets/logos/logo-alt.svg" style="max-height: 2.5rem">
              </router-link>
              <div class="nav-item nav-logos">
                <div>
                  <img src="/assets/hub.png">
                  <img src="/assets/ieca.svg">
                  <img src="/assets/dbe.svg">
                  <img src="/assets/sbe.svg">
                </div>
              </div>
            </div>
            <span :class="{'nav-toggle': true, 'is-active': navOpen}" @click="navOpen = !navOpen">
                          <span></span>
                          <span></span>
                          <span></span>
                        </span>
            <div :class="{'nav-right nav-menu': true, 'is-active': navOpen}" @click="navOpen = false">
              <router-link :to="{name: 'home'}" class="nav-item" exact>Home</router-link>
              <router-link :to="{name: 'services'}" class="nav-item">Services</router-link>
              <router-link :to="{name: 'portfolio'}" class="nav-item">Portfolio</router-link>
              <router-link :to="{name: 'calculator'}" class="nav-item">Estimator</router-link>
              <router-link :to="{name: 'contact'}" class="nav-item">Contact</router-link>
            </div>
          </div>
        </header>
      </div>

      <!-- Hero content: will be in the middle -->
      <div class="hero-body" v-if="$route.name === 'home'">
        <div class="bgvid">
          <video playsinline autoplay muted loop poster="../assets/bgs/palmfield.jpg" id="bgvid">
            <!--<source src="/assets/vid1.webm" type="video/webm">-->
            <source src="/assets/vid1.mp4" type="video/mp4">
          </video>
        </div>
        <div class="container has-text-white has-text-centered">
          <br />
          <img src="./assets/logos/logo.svg" class="hero-gulf-logo">
          <div class="header-logos">
            <img src="/assets/hub-invert.png" class="hero-wide-cert">
            <br />
            <img src="/assets/dbe-invert.svg" class="hero-narrow-cert">
            <img src="/assets/sbe-invert.svg" class="hero-narrow-cert">
            <br />
            <img src="/assets/ieca-invert.svg" class="hero-wide-cert">
          </div>
        </div>
      </div>

      <!-- Hero footer: will stick at the bottom -->
      <div :class="{'hero-foot': true, 'foot-has-affix': affix}" ref="footnav">
        <nav :class="{'tabs is-boxed is-fullwidth': true, 'foot-affix': affix}">
          <div class="container">
            <ul>
              <li :class="{'is-active': $route.name === 'trees'}">
                <router-link :to="{name: 'trees'}">Tree Relocation</router-link>
              </li>
              <li :class="{'is-active': $route.name === 'erosion'}">
                <router-link :to="{name: 'erosion'}">Erosion Control</router-link>
              </li>
              <li :class="{'is-active': $route.name === 'rows'}">
                <router-link :to="{name: 'rows'}">ROW Maintenance</router-link>
              </li>
              <li :class="{'is-active': $route.name === 'landscape'}">
                <router-link :to="{name: 'landscape'}">Landscaping</router-link>
              </li>
              <li :class="{'is-active': $route.name === 'irrigation'}">
                <router-link :to="{name: 'irrigation'}">Irrigation</router-link>
              </li>
              <li :class="{'is-active': $route.name === 'hydroaxe'}">
                <router-link :to="{name: 'hydroaxe'}">Hydro-Axing</router-link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </section>
    <section class="main">
      <router-view></router-view>
      <div class="footer-logos">
        <img src="/assets/hub.png">
        <img src="/assets/ieca.svg">
        <img src="/assets/dbe.svg">
        <img src="/assets/sbe.svg">
      </div>
    </section>
    <footer class="footer">
      <div class="container">
        <div class="footer-logo">
          <img src="./assets/logos/footer-logo.svg" style="max-width: 150px;">
        </div>
        <div class="content">
          <ul>
            <li>
              <router-link :to="{name:'home'}">Home</router-link>
            </li>
            <li>
              <router-link :to="{name:'services'}">Services</router-link>
            </li>
            <li>
              <router-link :to="{name:'portfolio'}">Portfolio</router-link>
            </li>
            <li>
              <router-link :to="{name:'calculator'}">Estimator</router-link>
            </li>
            <li>
              <router-link :to="{name:'contact'}">Contact</router-link>
            </li>
          </ul>
          <div class="inline-content">
            Gulf Coast Contractors, Inc.
            <br />
            &copy; 1995-2018 All Rights Reserved
          </div>
          <div class="inline-content">
            25691 Altas Palmas Road, Harlingen, TX 78552
            <br />
            (956) 412-6384 &nbsp; 1-877-MOV-TREE
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      navOpen: false,
      affix: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleAffix, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleAffix, { passive: true })
  },
  methods: {
    handleAffix() {
      let bounds = this.$refs.footnav.getBoundingClientRect()
      this.affix = bounds.top < 52
    }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?76328efc